module.exports = __webpack_public_path__ + "img/andersonaguiar.0968e238.jpg";